import React, { useState, useEffect, Fragment } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import backend from "../../../api";
import { loading, url_encode, copy_text_to_clipboard } from "../../../utils";
import { PrintComponents } from "react-print-components";
import AdCardLayout from "./AdCardLayout";
import AdCardShareModal from "./components/AdCardShareModal.jsx";

const AdCard = (props) => {
  const { id } = useParams();
  const { user } = useSelector((state) => state.auth);
  const history = useHistory();
  const [card, setCard] = useState(null);
  const [greeting, setGreeting] = useState("");
  const [title, setTitle] = useState("eksplode | Adcard ");
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);

  useEffect(() => {
    if (user) {
      backend
        .get("/greetings", { params: { member: user.user._id } })
        .then(({ data }) => {
          if (data && data.data && data.data[0] && data.data[0].greetings) {
            setGreeting(data.data[0].greetings);
          } else {
            console.error("Unexpected response format:", data);
          }
        })
        .catch((error) =>
          console.log(
            error.response ? error.response.data.message : error.message
          )
        );
    }
  }, [user]);

  useEffect(() => {
    loading(true);
    backend
      .get("/sharedlink", {
        params: {
          _id: id,
          populate: url_encode([
            {
              path: "product",
              populate: [
                {
                  path: "merchant_user",
                  select: "-password",
                },
              ],
            },
            {
              path: "member_user",
              select: "-password",
            },
          ]),
        },
      })
      .then(({ data }) => {
        if (data && data.data && data.data[0]) {
          setCard(data.data[0]);
          var d = new Date(data.data[0].expiry_date);
          d.setDate(d.getDate() + 30);
          setTitle("eksplode AdCard - " + data.data[0].product.product_name);
        } else {
          console.error("Unexpected response format:", data);
        }
      })
      .catch((error) => {
        console.error(
          error.response ? error.response.data.message : error.message
        );
        // history.replace("/shop");
      })
      .finally(() => {
        loading(false);
      });
  }, [id]);

  const handleCopyLink = () => {
    if (!card) {
      console.error("Card is not defined");
      return;
    }

    const baseUrl =
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_FRONTEND
        : process.env.REACT_APP_FRONTEND_DEV;

    const productUrl = new URL(card.shareable_link);
    productUrl.searchParams.set("promoted_by", card.member_user._id);
    productUrl.searchParams.set("id", card._id);

    const link = productUrl.toString();

    console.log("Generated link:", link);
    copy_text_to_clipboard(link);
    setShow(true);
    setTimeout(() => {
      setShow(false);
    }, 2000);
  };

  const buttonStyle = (buttonName) => ({
    backgroundColor: hoveredButton === buttonName ? "#dc3545" : "transparent",
    color: hoveredButton === buttonName ? "white" : "#dc3545",
    borderColor: "#dc3545",
    transition: "background-color 0.3s, color 0.3s", 
  });

  return (
    <Fragment>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="container mt-5">
        {card && (
          <div className="card border-0 rounded-lg p-4 mb-5">
            <div className="row no-gutters align-items-center">
              <div className="col-md-6 text-center">
                <img
                  src={card?.product?.product_images?.[0]?.image}
                  alt="Product"
                  className="img-fluid rounded mb-4"
                  style={{ maxHeight: "300px", objectFit: "cover" }} 
                />
              </div>
              <div className="col-md-6">
                <div className="p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h1 className="h3" style={{ color: "#dc3545" }}>
                      {card.product.product_name}
                    </h1>
                    <div>
                      <h6 className="text-secondary mb-0">Expiry Date</h6>
                      <p className="text-dark mb-0">
                        {new Date(card.expiry_date).toDateString()}
                      </p>
                    </div>
                  </div>
                  <p className="text-muted mb-4">{greeting}</p>
                  <p className="mb-4">{card.product.product_discription}</p>
                  <div className="d-flex flex-column">
                    <Link
                      to={"/product" + card.shareable_link.split("/product")[1]}
                      className="btn btn-danger mb-3"
                      style={{ backgroundColor: "#dc3545" }} 
                    >
                      View Product
                    </Link>
                    <button
                      className="btn btn-outline-danger mb-3"
                      style={buttonStyle("GetShareableLink")}
                      onMouseEnter={() => setHoveredButton("GetShareableLink")}
                      onMouseLeave={() => setHoveredButton(null)}
                      onClick={handleCopyLink}
                    >
                      Get Shareable Link
                    </button>
                    <button
                      className="btn btn-outline-danger mb-3"
                      style={buttonStyle("ShareWithContacts")}
                      onMouseEnter={() => setHoveredButton("ShareWithContacts")}
                      onMouseLeave={() => setHoveredButton(null)}
                      onClick={() => setOpen(true)}
                    >
                      Share with Contacts
                    </button>
                    <PrintComponents
                      trigger={
                        <button
                          className="btn btn-outline-danger"
                          style={buttonStyle("DownloadAdCard")}
                          onMouseEnter={() => setHoveredButton("DownloadAdCard")}
                          onMouseLeave={() => setHoveredButton(null)}
                        >
                          <i className="fas fa-file-pdf mr-2"></i> Download Ad
                          Card
                        </button>
                      }
                    >
                      <AdCardLayout
                        greetings={greeting}
                        card={card}
                      ></AdCardLayout>
                    </PrintComponents>
                    {show && (
                      <p className="text-success mt-3">
                        Link copied to clipboard
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modals */}
      {open && <AdCardShareModal open={open} setOpen={setOpen} card={card} />}
    </Fragment>
  );
};

export default AdCard;
